import { Pill } from "../theme";
import { toneColors } from "../pages/process/components/duimp";

const tones: Record<string, keyof typeof toneColors> = {
  Rascunho: "neutral",
  Enviado: "info",
  Aprovado: "success",
  Recusado: "danger",
};

/** Pílula do status do orçamento (Rascunho / Enviado / Aprovado / Recusado). */
const QuoteStatusPill = ({ status }: { status: string }) => <Pill {...toneColors[tones[status] ?? "neutral"]}>{status}</Pill>;

export default QuoteStatusPill;
